import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { vanherwerdenApi } from './service';

const store = configureStore({
  reducer: {
    [vanherwerdenApi.reducerPath]: vanherwerdenApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(vanherwerdenApi.middleware),
});

setupListeners(store.dispatch);

export default store;
